import React from 'react';
import './About.css';

const About = ({ currentLanguage }) => {
  const getTranslation = (key) => {
    const translations = {
      en: {
        title: 'About Master Ankit',
        journeyTitle: 'Journey into the Cosmic Realm',
        description: 'With over 10 years of dedicated practice in Vedic Astrology, Master Ankit Raval has guided thousands of souls towards their divine purpose. Born into a lineage of spiritual practitioners, he began his journey at the age of 12 under the tutelage of renowned Guru Vishwanath Sharma.'
      },
      hi: {
        title: 'मास्टर अंकित के बारे में',
        journeyTitle: 'ब्रह्मांडीय क्षेत्र में यात्रा',
        description: 'वैदिक ज्योतिष में 10 वर्षों से अधिक समर्पित अभ्यास के साथ, मास्टर अंकित रावल ने हजारों आत्माओं को उनके दिव्य उद्देश्य की ओर मार्गदर्शन किया है। आध्यात्मिक अभ्यासियों के वंश में जन्मे, उन्होंने प्रसिद्ध गुरु विश्वनाथ शर्मा के मार्गदर्शन में 12 वर्ष की आयु में अपनी यात्रा शुरू की।'
      },
      gu: {
        title: 'માસ્ટર અંકિત વિશે',
        journeyTitle: 'કોસ્મિક ક્ષેત્રમાં પ્રવાસ',
        description: 'વૈદિક જ્યોતિષમાં 10 વર્ષથી વધુ સમર્પિત અભ્યાસ સાથે, માસ્ટર અંકિત રાવલે હજારો આત્માઓને તેમના દિવ્ય ઉદ્દેશ્ય તરફ માર્ગદર્શન આપ્યું છે. આધ્યાત્મિક અભ્યાસીઓના વંશમાં જન્મેલા, તેમણે પ્રસિદ્ધ ગુરુ વિશ્વનાથ શર્માના માર્ગદર્શનમાં 12 વર્ષની ઉમરે પોતાની યાત્રા શરૂ કરી.'
      }
    };
    return translations[currentLanguage]?.[key] || translations.en[key];
  };

  return (
    <section id="about" className="about">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">{getTranslation('title')}</h2>
          <div className="section-divider"></div>
        </div>
        <div className="about-content">
          <div className="about-image">
            <div className="image-frame">
              <img src="/images/profile/main.png" alt="Master Ankit Raval with Virat Kohli" />
              <div className="image-overlay"></div>
            </div>
          </div>
          <div className="about-text">
            <h3>{getTranslation('journeyTitle')}</h3>
            <p>{getTranslation('description')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;